import React, { Component } from 'react'
import ReactGA from 'react-ga4'
export default class Banners extends Component {
  render() {
    return (
        <div className='flex flex-col h-full space-y-8 md:space-y-20 py-20 md:py-40 my-20 lg:my-40 px-4 md:px-0 items-center'>
            <h2 className='text-white text-md tracking-widest mb-12 lg:mb-20'>R-Type Series Links</h2>
            <div className='flex flex-col md:flex-row container md:space-x-16 space-x-0 space-y-8 md:space-y-0'>
                <div>
                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'external',
                                label: `rtf3e`,
                            })
                        }}
                        className='block cursor-pointer hover:shadow-3xl shadow-2xl hover:duration-700 hover:ease-in-out'
                        target='_blank'
                        rel='noreferrer'
                        href='https://nisamerica.com/r-type-final-3-evolved/'
                    >
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/rtype-portal-bannersrt3e.webp`}
                            alt='rtype final 3 banner'
                        />
                    </a>
                </div>
                <div>
                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'external',
                                label: `rtf2`,
                            })
                        }}
                        className='block cursor-pointer hover:shadow-3xl shadow-2xl hover:duration-700 hover:ease-in-out'
                        target='_blank'
                        rel='noreferrer'
                        href='https://nisamerica.com/r-type-final-2/'
                    >
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/rtype-portal-bannersrtf2.webp`}
                            alt='rtype final 2 banner'
                        />{' '}
                    </a>
                </div>{' '}
            </div>
            <a
                onClick={() => {
                    ReactGA.event({
                        action: 'click',
                        event: 'link',
                        category: 'external',
                        label: `portal`,
                    })
                }}
                className='block bg-rttcgreentint rounded-full backdrop-blur px-8 md:px-20 py-4 min-w-[200px] md:min-w-[300px] text-white cursor-pointer hover:shadow-2xl  duration-300 hover:ease-in-out'
                target='_blank'
                rel='noreferrer'
                href='https://nisamerica.com/r-type/'
            >
                <p className='text-sm tracking-wider text-center'>Portal</p>
            </a>
        </div>
    )
  }
}
